import React from 'react'
import { FormikProps, getIn } from 'formik'
import { NumberInput as UNumberInput } from 'bs-unified-ui'
import { useTheme } from '@mui/material/styles'

interface NumberInputProps {
  field: {
    name: string
    value: any
  }
  form: FormikProps<any>
  inputProps?: Record<string, any>
  error?: string
  helperText?: string
  disabled?: boolean
  [key: string]: any
}

const NumberInput: React.FC<NumberInputProps> = ({
  field,
  form,
  inputProps = {},
  error = '',
  helperText = '',
  disabled = false,
  ...props
}) => {
  const theme = useTheme()
  return (
    <UNumberInput
      error={
        !!error ||
        (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name))
      }
      helperText={
        helperText ||
        (getIn(form.touched, field.name) && getIn(form.errors, field.name))
      }
      inputProps={{
        ...field,
        ...inputProps,
        value: field.value ?? '',
      }}
      sx={{
        '& input:-internal-autofill-selected, input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
          {
            WebkitTextFillColor: `${theme.foreground.black} !important`,
          },
      }}
      disabled={disabled || !!form.values?.__readOnly}
      {...props}
    />
  )
}

export default NumberInput
